import { regionApi } from "src/api/region";
import { slice } from "src/slices/region";
import { store } from "src/store";
import { RegionScopes } from "src/utils/region-scope";

// 여러 차트가 동시에 mount되어도 scope별 지역 트리는 하나의 HTTP 요청만 공유한다.
const sidosRequests = new Map();
const structureSidosRequests = new Map();

const getSidos = (scope = RegionScopes.DEFAULT) => async (dispatch) => {
  const { sidosInit, analysisSidosInit } = store.getState().region;
  const initialized =
    scope === RegionScopes.ANALYSIS ? analysisSidosInit : sidosInit;
  if (initialized) return;

  // 첫 호출이 응답을 Redux에 넣기 전 들어온 후속 호출은 진행 중 Promise만 기다린다.
  if (sidosRequests.has(scope)) return sidosRequests.get(scope);
  const request = (async () => {
    const sidos = await regionApi.getSidos(scope);
    dispatch(slice.actions.getSidos({ scope, dto: sidos }));
  })();
  sidosRequests.set(scope, request);
  try {
    await request;
  } finally {
    // 실패한 요청도 제거하여 다음 화면 진입에서 정상적으로 재시도할 수 있게 한다.
    sidosRequests.delete(scope);
  }
};

/**
 * DataLake 요청 생성에 필요한 지역 구조를 CInfo 포함 트리와 분리해 한 번만 로드한다.
 */
const getSidosStructure = (scope = RegionScopes.DEFAULT) => async (dispatch) => {
  const { structureSidosInit, analysisStructureSidosInit } =
    store.getState().region;
  const initialized =
    scope === RegionScopes.ANALYSIS
      ? analysisStructureSidosInit
      : structureSidosInit;
  if (initialized) return;

  if (structureSidosRequests.has(scope)) {
    return structureSidosRequests.get(scope);
  }
  const request = (async () => {
    const dto = await regionApi.getSidos(scope, false);
    dispatch(slice.actions.getSidosStructure({ scope, dto }));
  })();
  structureSidosRequests.set(scope, request);
  try {
    await request;
  } finally {
    structureSidosRequests.delete(scope);
  }
};

const getSidosNames = () => async (dispatch) => {
  const data = await regionApi.getSidosNames();
  dispatch(slice.actions.getSidosNames(data));
};

const getGeoJson = () => async (dispatch) => {
  const { geojsonInit } = store.getState().region;
  if (!geojsonInit) {
    dispatch(slice.actions.getGeoJson(await regionApi.getGeoJson()));
  }
};

export const thunks = {
  getSidos,
  getSidosStructure,
  getSidosNames,
  getGeoJson,
};
